import { createSlice } from '@reduxjs/toolkit'
import {
  formSatisfied,
  getLandingUrlDto,
  getLandingUrlState,
} from 'features/creative/creativeUtil'
import { validateLandingUrlWithSiteUrl } from 'features/creative/add/common/useCreativeValidation'

export const rangeTypes = [
  { id: 'STATIC', name: '원' },
  { id: 'FROM', name: '원 부터' },
  { id: 'TO', name: '원 까지' },
]

export const validatePriceTableItem = price =>
  price.text !== '' &&
  price.price.match(/^[0-9]+$/) &&
  price.range !== null &&
  (price.landingUrl.individual
    ? price.landingUrl.mobileUrl !== '' || price.landingUrl.pcUrl !== ''
    : price.landingUrl.mobileUrl !== '')

export const validatePriceTable = (active, state, siteUrl) => ({
  prices: state.priceTables.map(({ text, price, landingUrl, range }, i) => {
    if (
      i > 0 &&
      (!formSatisfied(i, state.priceTables, validatePriceTableItem) ||
        (text === '' &&
          price === '' &&
          landingUrl.mobileUrl === '' &&
          landingUrl.pcUrl === ''))
    ) {
      return {
        description: false,
        price: false,
        mobileUrl: false,
        pcUrl: false,
      }
    } else {
      return {
        text: active && text === '' && '내용을 입력하세요.',
        price:
          active &&
          (!price.match(/^[0-9]+$/) || !range) &&
          '가격을 입력하세요.',
        ...(active && validateLandingUrlWithSiteUrl(landingUrl, siteUrl)),
      }
    }
  }),
})

export const getPriceTableAssetData = ({ priceTables }) => ({
  type: 'PRICE_TABLE',
  data: {
    priceTables: priceTables
      .filter(validatePriceTableItem)
      .map(({ text, price, range, landingUrl }) => ({
        text,
        price,
        range,
        landingUrl: getLandingUrlDto(landingUrl),
      })),
  },
})

const initialState = {
  priceTables: [
    {
      text: '',
      price: '',
      range: 'STATIC',
      landingUrl: {
        individual: false,
        mobileUrl: '',
        pcUrl: '',
      },
    },
    {
      text: '',
      price: '',
      range: 'STATIC',
      landingUrl: {
        individual: false,
        mobileUrl: '',
        pcUrl: '',
      },
    },
    {
      text: '',
      price: '',
      range: 'STATIC',
      landingUrl: {
        individual: false,
        mobileUrl: '',
        pcUrl: '',
      },
    },
  ],
}

const priceTableSlice = createSlice({
  name: 'priceTableSlice',
  initialState,
  reducers: {
    reset: () => initialState,
    setDescription: (state, { payload: { index, text } }) => {
      state.priceTables[index].text = text
    },
    setAllIndividualChecked: (state, { payload: individual }) => {
      state.priceTables.forEach(priceTable => {
        priceTable.landingUrl.individual = individual
      })
    },
    setIndividualChecked: (state, { payload: { index, checked } }) => {
      state.priceTables[index].landingUrl.individual = checked
    },
    setMobileUrl: (state, { payload: { index, url } }) => {
      state.priceTables[index].landingUrl.mobileUrl = url
    },
    setPcUrl: (state, { payload: { index, url } }) => {
      state.priceTables[index].landingUrl.pcUrl = url
    },
    setPrice: (state, { payload: { index, price } }) => {
      state.priceTables[index].price = price
    },
    setRange: (state, { payload: { index, range } }) => {
      state.priceTables[index].range = range
    },
    setPriceTable: (state, { payload: { priceTables } }) => {
      priceTables.forEach(({ text, price, range, landingUrl }, index) => {
        state.priceTables[index] = {
          text,
          price: price.toString(),
          range,
          landingUrl: getLandingUrlState(landingUrl),
        }
      })
    },
  },
})

export const {
  reset,
  setAllIndividualChecked,
  setIndividualChecked,
  setMobileUrl,
  setPcUrl,
  setDescription,
  setPrice,
  setRange,
  setPriceTable,
} = priceTableSlice.actions

export default priceTableSlice.reducer
